import type { LinkProps } from "@tanstack/react-router";
import type { MouseEventHandler } from "react";

import { Link } from "@tanstack/react-router";
import clsx from "clsx";

export type NavLinkProps = LinkProps & {
  isSelected?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const navLinkClassName =
  "block w-full rounded-lg p-2 font-sans text-white hover:bg-[color:var(--ps-color-cta-secondary-base--dark)]";

export const NavLink = ({ isSelected, onClick, ...rest }: NavLinkProps) => (
  <Link
    className={clsx(
      navLinkClassName,
      isSelected && "bg-cta-secondary-hover--dark",
    )}
    onClick={onClick}
    {...rest}
  />
);
